import { Dto, DtoWithId } from "@mango/core";


@Dto({fullName: "CIJBorculo.Logic.Soort"})
export class Soort extends DtoWithId {
	omschrijving: string;
}